import React, { Component } from "react";
import { CardTitle, Card, CardHeader, ButtonGroup, Button } from "reactstrap";
import { PlaylistService } from "../../services/playlistService";
import { Link } from "react-router-dom";
import {reloadPlaylist} from "../../redux/actions/index";
import { connect } from "react-redux";
import { Search } from "../../containers";
import { ModalDelete } from "../../containers";
import SearchInput, { createFilter } from "react-search-input";
import PropTypes from "prop-types";
const KEYS_TO_FILTERS = ["place", "manager", "email"];

let playlistService = new PlaylistService();

class TableHead extends Component {
  render() {
    return (
      <thead>
        <tr>
          <th onClick={()=> this.props.orderColumn('name')}><i className="fa fa-sort"><b>Nombre</b></i></th>
          <th onClick={()=> this.props.orderColumn('type')}><i className="fa fa-sort"><b>Tipo</b></i></th>
          <th onClick={()=> this.props.orderColumn('path')}><i className="fa fa-sort"><b>PATH</b></i></th>
          <th />
        </tr>
      </thead>
    );
  }
}

class Playlist extends Component {
  constructor(props) {
    super(props);
    this.state = {
      deleting: false
    };
    this.toogleDelete = this.toogleDelete.bind(this);
    this.sendDelete = this.sendDelete.bind(this);
  }
  toogleDelete() {
    this.setState({
      deleting: !this.state.deleting
    });
  }
  sendDelete() {
    let self = this;
    playlistService.deleteById(this.props.item.id).then(function(data) {
      playlistService.reload();
      self.context.getNotificationSystem().addNotification({
        message:
          "Se ha eliminado exitosamente la Playlist: " +
          self.props.item.name +
          ".",
        title: "Playlist Eliminado",
        level: "success"
      });
      self.toogleDelete();
    });
  }
  render() {
    let deleting = this.state.deleting;
    let item = this.props.item;
    return (
      <tr>
        <td>
          {item.name}
          <div className="small text-muted">
            Nombre: {item.name}
          </div>
        </td>
        <td>{item.type}</td>
        <td>{item.path}</td>

        {this.props.viewButton && (
          <td className="text-center">
            <ButtonGroup className="mr-3" aria-label="First group">
              <Button
                onClick={this.toogleDelete}
                className="btn btn-danger btn-sm"
              >
                <i className="fa fa-trash" />{" "}
                {deleting && (
                  <ModalDelete
                    show={deleting}
                    close={this.toogleDelete}
                    sendDelete={this.sendDelete}
                    name={this.props.item.name}
                    entityName="la Playlist"
                  />
                )}
              </Button>
              <Link
                to={"/playlists/edit/" + this.props.item.id}
                className="btn btn-primary btn-sm"
              >
                <i className="fa fa-pencil" />
              </Link>
            </ButtonGroup>
          </td>
        )}
      </tr>
    );
  }
}

Playlist.contextTypes = {
  getNotificationSystem: PropTypes.func.isRequired
};

class PlaylistConnector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      loading: true,
      searchTerm: ""
    };
    this.mounted = true;
    this.loadData(this);
    this.searchUpdated = this.searchUpdated.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }
  componentWillUnmount() {
    this.mounted = false;
  }
  searchUpdated(term) {
    this.setState({ searchTerm: term });
  }
  handleChange(event) {
    this.setState({ [event.target.id]: event.target.value });
  }
  loadData(self) {
    playlistService
      .read()
      .then(function(data) {
        if (!data.hasOwnProperty("error")) {
          self.props.reloadPlaylist(data);
        }
        if (self.mounted)
          self.setState({
            loading: false
          });
      })
      .catch(function(error) {
        console.log(error);
      });
  }
  render() {
    let data = this.props.data;
    let user = this.props.user.user;
    let filtered = data;
    filtered = filtered.filter(
      createFilter(this.state.searchTerm, KEYS_TO_FILTERS)
    );
    return (
      <div className="animated fadeIn">
        <Card>
          <CardHeader>
            <div className="d-sm-flex w-100 justify-content-between">
              <CardTitle className="mb-0">Playlists</CardTitle>

              <h6 className="mb-1 col-sm-5">
                <SearchInput
                  className="search-input input-group"
                  inputClassName="form-control"
                  placeholder="Buscar..."
                  onChange={this.searchUpdated}
                />
              </h6>
              <h6 className="mb-1">
                <div className="card-header-actions">
                  <Link
                    to={"/playlists/create"}
                    className="btn btn-default btn-sm float-right"
                  >
                    Agregar Playlist <i className="fa fa-plus" />
                  </Link>
                </div>
              </h6>
            </div>
          </CardHeader>
          <Search
            table={true}
            Thead={TableHead}
            data={filtered}
            ObjectTemplate={Playlist}
            loading={this.state.loading}
            bordered={false}
            striped={false}
            viewButton={user.role === "ADMIN"}
          />
        </Card>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    data: state.playlists,
    user: state.user
  };
};

const mapDispatchToProps = dispatch => {
  return {
    reloadPlaylist: playlists => dispatch(reloadPlaylist(playlists))
  };
};

const Playlists = connect(
  mapStateToProps,
  mapDispatchToProps
)(PlaylistConnector);

export default Playlists;
